<template>
    <div v-if="showExportCsv" class="search-result-export">
        <div style="padding-bottom: 10px; text-align: left; font-size: 13px; padding-left: 35px;">
            <span @click="reset" class="dashed" style="display: inline-block; margin-right: 15px;">Установить все</span>
            <span @click="unset" class="dashed" style="display: inline-block; margin-right: 15px;">Снять все</span>
            <span @click="simpleSet" class="dashed" style="display: inline-block; margin-right: 15px;">Простая выгрузка</span>
        </div>
        <ul>
            <li><input type="checkbox" data-field="ogrn" v-model="ogrn"/>ОГРН</li>
            <li><input type="checkbox" data-field="inn" v-model="inn"/>ИНН</li>
            <li><input type="checkbox" data-field="name_short" v-model="name_short"/>Сокращённое наименование</li>
            <li><input type="checkbox" data-field="name_full" v-model="name_full"/>Полное наименование</li>
            <li><input type="checkbox" data-field="okpo" v-model="okpo"/>ОКПО</li>
            <li><input type="checkbox" data-field="okato" v-model="okato"/>ОКАТО</li>
            <li><input type="checkbox" data-field="okfs" v-model="okfs"/>ОКФС</li>
            <li><input type="checkbox" data-field="okopf" v-model="okopf"/>ОКОПФ</li>
            <li><input type="checkbox" data-field="kpp" v-model="kpp"/>КПП</li>
            <li><input type="checkbox" data-field="date_start" v-model="date_start"/>Дата регистрации</li>
            <li><input type="checkbox" data-field="date_stop" v-model="date_stop"/>Дата ликвидации</li>
            <li><input type="checkbox" data-field="okved" v-model="okved"/>ОКВЭД</li>
            <li><input type="checkbox" data-field="rukovod" v-model="rukovod"/>Руководитель</li>
            <li><input type="checkbox" data-field="address" v-model="address"/>Адрес</li>
            <li><input type="checkbox" data-field="phone" v-model="phone"/>Телефон</li>
            <li><input type="checkbox" data-field="site" v-model="site"/>Сайт</li>
            <li><input type="checkbox" data-field="email" v-model="email"/>Эл. почта</li>
            <li><input type="checkbox" data-field="auth_capital" v-model="auth_capital"/>Уставный капитал</li>
            <li><input type="checkbox" data-field="viruch" v-model="viruch"/>Выручка</li>
            <li><input type="checkbox" data-field="osn_sreds" v-model="osn_sreds"/>Основные средства</li>
            <li><input type="checkbox" data-field="zapas" v-model="zapas"/>Запасы</li>
            <li><input type="checkbox" data-field="deb_zadolj" v-model="deb_zadolj"/>Дебиторская задолженность</li>
            <li><input type="checkbox" data-field="kred_zadolj" v-model="kred_zadolj"/>Кредиторская задолженность</li>
            <li><input type="checkbox" data-field="chist_pribil" v-model="chist_pribil"/>Чистая прибыль</li>
            <li><input type="checkbox" data-field="pribil" v-model="pribil"/>Прибыль от продаж</li>
            <li><input type="checkbox" data-field="pribil_do_nalog" v-model="pribil_do_nalog" />Прибыль до налогов</li>
            <li v-if="this.$store.state.specialPriviliges.employeeCount.includes(this.$store.state.apiUser)"><input type="checkbox" data-field="employee_counts" v-model="employee_counts" />Кол-во сотрудников</li>
        </ul>
        <button @click="e => { exportClick('csv') }" class="search-result-export-submit" title="Скачать CSV (в формате Юникод UTF-8)">
            <i class="lnr lnr-download"></i> Скачать CSV
        </button>
        <button @click="e => { exportClick('xlsx') }" class="search-result-export-submit" title="Скачать CSV (в формате Юникод UTF-8)">
            <i class="lnr lnr-download"></i> Скачать XLSX
        </button>
    </div>
</template>

<script>


export default {
    methods: {
        exportClick(result_type){
            const list_fields = Object.keys(this.csvExportParams ?? {}).filter(e => this.csvExportParams[e])
            this.$store.dispatch('search/exportCsvXls', {
                result_type,
                list_fields
            })
        },
        reset() { this.$store.commit('search/resetCsvExportParams') },
        unset() { this.$store.commit('search/unsetCsvExportParams') },
        simpleSet() { this.$store.commit('search/simpleCsvExport') }
    },
    computed: {
        csvExportParams() { return this.$store.state.search?.csvExportParams },
        showExportCsv(){ return this.$store.state.search.showExportCsv },
        ogrn: {
            get() { return this.$store.state.search?.csvExportParams.ogrn },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'ogrn', value }) }
        },
        inn: {
            get() { return this.$store.state.search?.csvExportParams.inn },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'inn', value }) }
        },
        name_short: {
            get() { return this.$store.state.search?.csvExportParams.name_short },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'name_short', value }) }
        },
        name_full: {
            get() { return this.$store.state.search?.csvExportParams.name_full },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'name_full', value }) }
        },
        okpo: {
            get() { return this.$store.state.search?.csvExportParams.okpo },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'okpo', value }) }
        },
        okato: {
            get() { return this.$store.state.search?.csvExportParams.okato },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'okato', value }) }
        },
        okfs: {
            get() { return this.$store.state.search?.csvExportParams.okfs },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'okfs', value }) }
        },
        okopf: {
            get() { return this.$store.state.search?.csvExportParams.okopf },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'okopf', value }) }
        },
        kpp: {
            get() { return this.$store.state.search?.csvExportParams.kpp },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'kpp', value }) }
        },
        date_start: {
            get() { return this.$store.state.search?.csvExportParams.date_start },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'date_start', value }) }
        },
        date_stop: {
            get() { return this.$store.state.search?.csvExportParams.date_stop },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'date_stop', value }) }
        },
        okved: {
            get() { return this.$store.state.search?.csvExportParams.okved },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'okved', value }) }
        },
        rukovod: {
            get() { return this.$store.state.search?.csvExportParams.rukovod },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'rukovod', value }) }
        },
        address: {
            get() { return this.$store.state.search?.csvExportParams.address },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'address', value }) }
        },
        phone: {
            get() { return this.$store.state.search?.csvExportParams.phone },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'phone', value }) }
        },
        site: {
            get() { return this.$store.state.search?.csvExportParams.site },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'site', value }) }
        },
        email: {
            get() { return this.$store.state.search?.csvExportParams.email },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'email', value }) }
        },
        auth_capital: {
            get() { return this.$store.state.search?.csvExportParams.auth_capital },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'auth_capital', value }) }
        },
        viruch: {
            get() { return this.$store.state.search?.csvExportParams.viruch },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'viruch', value }) }
        },
        osn_sreds: {
            get() { return this.$store.state.search?.csvExportParams.osn_sreds },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'osn_sreds', value }) }
        },
        zapas: {
            get() { return this.$store.state.search?.csvExportParams.zapas },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'zapas', value }) }
        },
        deb_zadolj: {
            get() { return this.$store.state.search?.csvExportParams.deb_zadolj },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'deb_zadolj', value }) }
        },
        kred_zadolj: {
            get() { return this.$store.state.search?.csvExportParams.kred_zadolj },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'kred_zadolj', value }) }
        },
        chist_pribil: {
            get() { return this.$store.state.search?.csvExportParams.chist_pribil },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'chist_pribil', value }) }
        },
        pribil: {
            get() { return this.$store.state.search?.csvExportParams.pribil },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'pribil', value }) }
        },
        pribil_do_nalog: {
            get() { return this.$store.state.search?.csvExportParams.pribil_do_nalog },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'pribil_do_nalog', value }) }
        },
        employee_counts: {
            get() { return this.$store.state.search?.csvExportParams.employee_counts },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'employee_counts', value }) }
        },
        msp: {
            get() { return this.$store.state.search?.csvExportParams.msp },
            set(value) { this.$store.commit('search/setCsvExportParam', { key: 'msp', value }) }
        }
    }
}
</script>

<style scoped>
.search-result-export { background: #f0f0f0; padding-top: 20px !important; padding-bottom: 20px !important; text-align: center; }
.search-result-export ul { font-size: 0; line-height: 20px; text-align: left; }
.search-result-export ul li { display: inline-block; white-space: nowrap; margin-right: 20px; font-size: 13px;  }

.search-result-export-submit {
	display: inline-block;
	background: #F5D76E;
	padding: 10px 20px;
	font-size: 14px; font-weight: 700;
	border-radius: 4px;
	cursor: pointer;	
    border: none;
}
</style>
